module.exports = __webpack_public_path__ + "static/img/kh-1.af19386.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kh-1.png
// module id = 7Wpk
// module chunks = 5